import Control from './Control';
import ErrorBoundary from './ErrorBoundary';

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <Control />
      </ErrorBoundary>
    </div>
  );
}

export default App;
